<template>
      <div class="container-fluid">
      <div class="row">
        <div class="columns is-desktop">
          <div class="column is-6-desktop pt-0 pb-0 pl-0 pr-0" style="line-height:0px">
            <img  src="@/assets/img/bigImage2.jpg" class="width100 mt3 mb3">
          </div>       
          <div class="column is-6-desktop pt-0 pl-0 pr-0  mt3 mb3 bgColorPrimary
          paddingMobileNow">
              <h1 class="has-text-dark marginTopMobileFont pt-6 pb-6  pl-3 pr-3
                    has-text-centered is-block mx-auto widthMaxResponsive2 ">
                    <font-awesome-icon class="is-hidden has-text-dark is-size-1 mb-4" :icon="['fa', 'home']"  />

                    <br><br>
                     <span class="fontWeightRegular fontNoSoBlack
                     is-size-4-desktop is-size-1-tablet is-size-3-mobile is-size-1-widescreen">
                   
                    </span>
                    <span class="fontWeightBlack is-size-1-tablet
                    is-size-4-desktop is-size-3-mobile is-size-1-widescreen"> Profesionalidad y confianza</span>
                    <br>
                    <div class="separatorLine bgColorSecondary width20 mt-3 mx-auto is-block opacity08"></div>
                    <br>
                    <span class="fontWeightRegular is-size-4-tablet is-size-5-desktop is-size-4-mobile is-size-4-widescreen">
                    Ofrecemos un servicio <span class="fontWeightBold">que nos destaca por nuestra competitividad en los precios
                      y la confianza de saber que llevamos más de 15 años trabajando en la ciudad.</span>
                    </span>
                    <br><br>
                    <span class="fontWeightLight fontNoSoBlack is-size-5 letterSpacingMedium fontItalic">
                    Contratá el mejor servicio de la ciudad
                    </span>
              </h1>
          </div>            
        </div> 
      </div>         
    </div> 
</template>

<script>
export default {

}
</script>

<style>

</style>